module.exports = __webpack_public_path__ + "static/media/img_money_pack@3x.af0c7e9f.png";